const getters = {
  glazeUrl (state) {
    return state.env.glazeUrl;
  }
};

export default getters;
